import {
  notificationsConfig,
  NOTIFICATION_INBOX_TABS,
} from "../config/notifications.config.js";
import { isNotificationUnread } from "./format-notification-display.js";
import { sortNotificationsByReadAtDesc } from "./sort-notifications-by-read-at-desc.js";

/**
 * Essencial já lida (histórico da aba Lidas).
 * @param {Object} [notification]
 * @returns {boolean}
 */
export function isEssentialReadNotification(notification) {
  return (
    Boolean(notification?.isEssential) && !isNotificationUnread(notification)
  );
}

/**
 * Filtra a lista conforme a aba do inbox.
 * - `pending`: todas não lidas
 * - `essential-read`: essenciais lidas, no máx. `readInboxLimit` mais recentes
 *
 * @param {Object[]} [notifications]
 * @param {string} [tab]
 * @returns {Object[]}
 */
export function filterNotificationsByInboxTab(
  notifications,
  tab = NOTIFICATION_INBOX_TABS.pending,
) {
  const list = Array.isArray(notifications) ? notifications : [];

  if (tab === NOTIFICATION_INBOX_TABS.essentialRead) {
    const limit = Number(notificationsConfig.readInboxLimit) || 10;
    return sortNotificationsByReadAtDesc(
      list.filter(isEssentialReadNotification),
    ).slice(0, Math.max(0, limit));
  }

  return list.filter((item) => isNotificationUnread(item));
}
